import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MOActions from '@Actions/moActions';
import H3FormInput from '@Uilib/h3FormInput';
import H3Text from '@Uilib/h3Text';
import { Alert, Button } from 'antd';
import BatchSelectorForFG from '../../../ManufacturingOrders/ViewManufacturingOrder/BatchSelectorForFG';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScrewdriverWrench, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { INFINITE_EXPIRY_DATE } from '@Apis/constants';
import dayjs from 'dayjs';
import './style.scss';
import CustomFieldHelpers from '../../../../../helpers/CustomFieldHelpers';
/**
 *
 */
function JwQuantityUpdate({
  updateType, quantity, uomInfo, selectedJobWork, selectedOutputMaterial, createMOAdjustment, createMOAdjustmentLoading, callback, cfV2DocManufacturingOrder, user,
}) {
  const [completed, setCompleted] = useState('');
  const [rework, setRework] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [batchNumber, setBatchNumber] = useState('');
  const [landedCost, setLandedCost] = useState(0);
  const [margin, setMargin] = useState(0);
  const [isBatchValid, setIsBatchValid] = useState(false);
  const [lotNumber, setLotNumber] = useState('');
  const [arNumber, setArNumber] = useState('');
  const [fgBatchCostPrice, setFgBatchCostPrice] = useState(0);
  const [sellingPrice, setSellingPrice] = useState(0);
  const [mrp, setMrp] = useState(0);
  const [barcode, setBarcode] = useState('');
  const [rollNumber, setRollNumber] = useState('');
  const [freightCost, setFreightCost] = useState(0);
  const [otherCost, setOtherCost] = useState(0);
  const [brand, setBrand] = useState('');
  const [mfgBatchNumber, setMfgBatchNumber] = useState('');
  const [mfgDate, setMfgDate] = useState(dayjs());
  const [expiryDate, setExpiryDate] = useState('');
  const [showLess, setShowLess] = useState(true);
  const [inventoryLocation, setInventoryLocation] = useState(null);
  const [rejected, setRejected] = useState('');
  const [batchCustomFields, setBatchCustomFields] = useState();
  const currentPending = Number(Number(Number(quantity) - Number(completed) - Number(rework) - (Number(rejected))).toFixed(uomInfo?.precision));
  let tenantDepartmentIdFromJwInfo = null;

  if (selectedJobWork?.output_materials?.length > 0) {
    const MoLineIdForDep = selectedJobWork.output_materials[0]?.mo_line_id_for_department ? selectedJobWork?.rm_tenant_department_id : null;
    const MoFgIdForDep = selectedJobWork.output_materials[0]?.mo_fg_id_for_department ? selectedJobWork?.fg_tenant_department_id : null;
    tenantDepartmentIdFromJwInfo = MoLineIdForDep || MoFgIdForDep;
  } else if (selectedJobWork?.processing_materials?.length > 0) {
    const MoLineIdForDep = selectedJobWork.processing_materials[0]?.mo_line_id_for_department ? selectedJobWork?.rm_tenant_department_id : null;
    const MoFgIdForDep = selectedJobWork.processing_materials[0]?.mo_fg_id_for_department ? selectedJobWork?.fg_tenant_department_id : null;
    tenantDepartmentIdFromJwInfo = MoLineIdForDep || MoFgIdForDep;
  }

  useEffect(() => {
    setBatchNumber(selectedJobWork?.fg_adjustment?.custom_batch_number);
    if (selectedOutputMaterial?.expiry_days === -1) {
      setExpiryDate(dayjs(INFINITE_EXPIRY_DATE))
    } else {
      setExpiryDate(dayjs().add(selectedOutputMaterial?.expiry_days, 'day'))
    }
  }, []);

  useEffect(() => {

    if (cfV2DocManufacturingOrder?.data?.success) {
      setBatchCustomFields(CustomFieldHelpers.getCfStructure(cfV2DocManufacturingOrder?.data?.batch_custom_fields, true));
    }
  }, [cfV2DocManufacturingOrder]);

  const cfDataValid = () => {

    for (const field of batchCustomFields) {
      if (field?.isActive && field?.isRequired && (field?.fieldValue === undefined || field?.fieldValue === 0 || field?.fieldValue === '')) {
        return false;
      }
    }
    return true;
  }

  const submit = () => {
    const rejectedQty = Number(rejected) + Number(selectedJobWork?.rejected_qty);
    setFormSubmitted(true);
    if (!cfDataValid()) {
      return;
    }
    const payload = [{
      entity_type: selectedOutputMaterial?.mo_fg_id ? 'FINISHED_GOOD' : 'SEMI_FINISHED_GOOD',
      entity_id: selectedOutputMaterial?.mo_fg_id ?? selectedOutputMaterial?.mo_line_id,
      quantity: Number(completed),
      mo_id: selectedJobWork?.mo_id,
      status: 'ISSUED',
      batch_id: null,
      cost_price: Number(fgBatchCostPrice),
      selling_price: Number(sellingPrice),
      landed_cost: Number(landedCost),
      ar_number: arNumber,
      mrp: mrp,
      barcode: barcode,
      roll_number: rollNumber,
      freight_code: Number(freightCost),
      other_cost: Number(otherCost),
      brand: brand,
      mfg_batch_number: mfgBatchNumber,
      mfg_date: mfgDate,
      inventory_location_id: inventoryLocation,
      margin: margin,
      lot_number: lotNumber || '',
      custom_batch_number: selectedJobWork?.fg_adjustment?.custom_batch_number,
      expiry_date: expiryDate,
      wastage_quantity: 0,
      production_route_line_id: selectedOutputMaterial?.production_route_line_id,
      prl_output_material_id: selectedOutputMaterial?.prl_output_material_id,
      rework_qty: updateType === 'PENDING' ? (Number(selectedJobWork?.rework_qty) + Number(rework)) : (Number(quantity) - Number(completed) - Number(rejected)),
      pending_qty: updateType === 'PENDING' ? currentPending : selectedJobWork?.pending_qty,
      rejected_qty: rejectedQty,
      desired_output: Number(completed),
      custom_fields: CustomFieldHelpers.postCfStructure(batchCustomFields),
    }]
    if ((completed >= 0 || rework >= 0) || rejected >= 0) {
      createMOAdjustment({
        mo_adjustments: payload,
      }, () => {
        callback();
        setFormSubmitted(false);
      });
    }
  };
  return (
    <div className="jw-quantity-form__wrapper">
      <div className="jw-quantity-form__title">
        <H3Text text={`${updateType === 'PENDING' ? 'Pending' : 'Rework'} Quantity`} className="jw-quantity-form__title-label" />
        <H3Text text={`${currentPending} ${uomInfo?.uqc?.toProperCase()}`} className="jw-quantity-form__title-value" />
      </div>
      <div className="ant-row mg-bottom-10">
        <div className="ant-col-md-24">
          <div className="jw-quantity-form__input jw-quantity-form__input-success">
            <div className="flex-display">
              <FontAwesomeIcon icon={faCircleCheck} />
              <H3FormInput
                label="Completed Quantity"
                value={completed}
                type="number"
                containerClassName="orgInputContainer"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                onChange={(e) => setCompleted(e.target.value)}
              />
            </div>
            <BatchSelectorForFG
              formSubmitted={formSubmitted}
              setFormSubmitted={(value) => setFormSubmitted(value)}
              setIsBatchValid={(value) => setIsBatchValid(value)}
              isBatchValidValue={isBatchValid}
              batchNumber={batchNumber}
              setBatchNumber={(value) => setBatchNumber(value)}
              disabled={createMOAdjustmentLoading}
              isBatchNumberEditable={true}
              lotNumber={lotNumber}
              setLotNumber={(value) => setLotNumber(value)}
              arNumber={arNumber}
              setArNumber={(value) => setArNumber(value)}
              fgBatchCostPrice={fgBatchCostPrice}
              setFgBatchCostPrice={(value) => setFgBatchCostPrice(value)}
              sellingPrice={sellingPrice}
              setSellingPrice={(value) => setSellingPrice(value)}
              mrp={mrp}
              setMrp={(value) => setMrp(value)}
              barcode={barcode}
              setBarcode={(value) => setBarcode(value)}
              rollNumber={rollNumber}
              setRollNumber={(value) => setRollNumber(value)}
              freightCost={freightCost}
              setFreightCost={(value) => setFreightCost(value)}
              otherCost={otherCost}
              setOtherCost={(value) => setOtherCost(value)}
              landedCost={landedCost}
              setLandedCost={(value) => setLandedCost(value)}
              margin={margin}
              setMargin={(value) => setMargin(value)}
              brand={brand}
              setBrand={(value) => setBrand(value)}
              mfgBatchNumber={mfgBatchNumber}
              setMfgBatchNumber={(value) => setMfgBatchNumber(value)}
              mfgDate={mfgDate}
              setMfgDate={(value) => setMfgDate(value)}
              expiryDate={expiryDate}
              setExpiryDate={(value) => setExpiryDate(value)}
              showLess={showLess}
              setShowLess={() => setShowLess(!showLess)}
              inventoryLocation={inventoryLocation}
              setInventoryLocation={(value) => setInventoryLocation(value)}
              destDepartmentId={tenantDepartmentIdFromJwInfo}
              containerClassName="fg-batch-input__wrapper"
              batchCf={batchCustomFields}
              setBatchCf={value => setBatchCustomFields(value)}
            />
          </div>
        </div>
        <div className="ant-col-md-24">
          <H3FormInput
            label="Rework Quantity"
            value={rework}
            type="number"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            onChange={(e) => setRework(e.target.value)}
          />
        </div>
        <div className="ant-col-md-24">
          <H3FormInput
            label="Rejected Quantity"
            value={rejected}
            type="number"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            onChange={(e) => setRejected(e.target.value)}
          />
        </div>
      </div>
      {formSubmitted && currentPending < 0 && (
        <Alert
          type="error"
          message={`Completed + Rejected + Rework quantity should be less than ${updateType?.toProperCase()} quantity`}
          showIcon
        />
      )}
      <div className="custom-drawer__footer">
        <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
          <Button
            type="primary"
            onClick={() => submit()}
            loading={createMOAdjustmentLoading}
            disabled={createMOAdjustmentLoading}
          >Update Quantity</Button>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({
  UserReducers, MOReducers, JobWorkReducers, CFV2Reducers,
}) => ({
  user: UserReducers.user,
  createMOAdjustmentLoading: MOReducers.createMOAdjustmentLoading,
  cfV2DocManufacturingOrder: CFV2Reducers.cfV2DocManufacturingOrder,
});

const mapDispatchToProps = (dispatch) => ({
  createMOAdjustment: (payload, callback) => dispatch(MOActions.createMOAdjustment(payload, callback)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(JwQuantityUpdate));
